import { Day } from 'react-modern-calendar-datepicker';

export const normalizeDay = (day: Day) => ({
  toDate: (): Date => {
    const date = new Date();

    date.setFullYear(day.year);

    date.setMonth(day.month - 1);

    date.setDate(day.day);

    return date;
  },
});
